<script setup lang="ts">
  import type { Call, Task } from '@api/models';
  import { nextTick } from 'vue';

  import { Sheet, SheetContent } from '@ui/components/sheet';

  import { CallView } from '@/components/calls/index';
  import { useTaskCollectionStore } from '@/store';

  const props = defineProps<{ call?: Call | null }>();

  const emits = defineEmits<{ (e: 'close'): void }>();
  const taskCollectionStore = useTaskCollectionStore();

  const openTask = (task: Task) => {
    emits('close');

    nextTick(() =>
      setTimeout(() => {
        taskCollectionStore.openTaskByQuery?.(task);
      }, 0),
    );
  };
</script>

<template>
  <Sheet v-bind="$attrs">
    <SheetContent
      side="right"
      floating
      close-position="right"
      class="lg:min-w-[60vw]! lg:max-w-[80vw]! pt-2"
      default-open
      style="width: calc(100% - 1rem)"
      :disable-dismiss-on="['interact-outside']"
      @close="emits('close')"
      @close-auto-focus="
        (e) => {
          e.preventDefault();
        }
      "
    >
      <CallView v-if="call" :call @open-task="openTask" @close="emits('close')" />
    </SheetContent>
  </Sheet>
</template>

<style scoped></style>
